
import { defineComponent, PropType } from 'vue';

import { ValidationRule } from '@/common/validation/helpers';
import { useVModelProxy } from '@/composables';

export default defineComponent({
	inheritAttrs: false,

	props: {
		name: {
			type: String,
			required: true
		},

		rules: {
			type: [String, Function, Array, Object] as PropType<ValidationRule>,
			default: () => []
		},

		validateOnMount: {
			type: Boolean
		},

		modelValue: {
			type: [String, Number],
			default: ''
		}
	},

	emit: ['update:modelValue'],

	setup(props, { emit }) {
		return {
			model: useVModelProxy(props, emit)
		};
	}
});
